import slugify from '@/filters/slugify';

export default {
  getFinances: (state) => state.finances,
  getFinanceInfo: (state) => state.financeInfo,
  // General
  getCommercialists: (state) => state.commercialists,
  getPager: (state) => state.pager,

  // Towns
  getTowns: (state) => state.towns,
  getTown: (state) => state.town,
  getSimplifiedTowns: (state) => state.towns.map((item) => ({
    label: item.title,
    id: item.id,
  })),

  // Users
  getShippingTowns: (state) => state.shippingTowns,
  getUsers: (state) => state.users,
  getSelectedUser: (state) => state.selectedUser,
  getUserShippingInfo: (state) => state.userShippingInfo,
  getToken: (state) => state.token,
  getLoggedUser: (state) => state.profile,
  getProfile: (state) => state.userProfile,
  getShippingAddresses: (state) => state.shippingAddresses,
  getShippingAddress: (state) => state.shippingAddress,
  getShippingAddressesFiltered: (state) => state.shippingAddressesFiltered,

  // Countries
  getCountries: (state) => state.countries,
  getSimplifiedCountries: (state) => state.countries.map((item) => ({
    label: item.title,
    id: item.id,
  })),
  getCountry: (state) => state.country,

  // Categories
  getCategories: (state) => state.categories,
  // eslint-disable-next-line
  getCategoriesTreeView: (state) => {
    function generateTree(categories, parentId = null) {
      const tree = [];
      categories
        .filter((category) => category.parentCategoryId === parentId)
        .forEach((category) => {
          const node = {
            id: category.id,
            label: category.title,
            slug: slugify(category.title),
            numberOfArticles: category.numberOfArticles,
            parentCategoryId: category.parentCategoryId,
            order: category.order || 0,
            children: generateTree(categories, category.id),
          };
          tree.push(node);
        });
      return tree;
    }

    const sortMethod = (a, b) => a.order - b.order;

    return generateTree([...state.categories].sort(sortMethod), null);
  },

  getChildrenCategoryIds: (state) => (parentId) => {
    const getChildCategoryIds = (categories, categoryId) => {
      const childIds = [];

      const getChildren = (id) => {
        categories.filter((c) => c.parentCategoryId === id).forEach((child) => {
          childIds.push(child.id);
          getChildren(child.id);
        });
      };

      getChildren(categoryId);
      return childIds;
    };

    return getChildCategoryIds(state.categories, parentId);
  },
  getArticleParentCategories: (state) => (categoryId) => {
    function findParentCategories(categories, id) {
      const parentCategories = [];

      // Find the category with the provided categoryId
      const category = categories.find((cat) => cat.id === id);

      if (category) {
        // If the category has a parentCategoryId, recursively find its parent categories
        if (category.parentCategoryId !== null) {
          const parentCategory = findParentCategories(categories, category.parentCategoryId);
          parentCategories.push(...parentCategory);
        }

        // Add the current category to the parentCategories list
        parentCategories.push(category);
      }
      return parentCategories;
    }

    return findParentCategories(state.categories, categoryId);
  },
  getSimplifiedCategories: (state) => state.simplifiedCategories,
  getCategory: (state) => state.category,
  getCategoryById: (state) => (id) => state.categories.find((item) => item.id === parseInt(id, 10)),
  getSubCategories:
    (state) => (id) => state.categories.filter(
      (item) => item.parentCategoryId === parseInt(id, 10),
    ),

  // Companies
  getSuperBonusByCompany: (state) => state.superBonusByCompany,

  // Articles
  getArticles: (state) => state.articles,
  getArticle: (state) => state.article,
  getUserArticles: (state) => {
    const articles = [...state.userArticles];
    if (articles.length > 10) {
      articles.length = 10;
    }
    return articles;
  },
  getUserArticlesFilter: (state) => state.userArticlesFilter,
  getAllUserArticles: (state) => state.userArticles,
  getNewlyAddedArticles: (state) => state.newlyAddedArticles,
  getNewlyAddedArticlesFilter: (state) => state.newlyAddedArticlesFilter,
  getReviews: (state) => state.reviews,
  getSearchArticles: (state) => state.searchArticles,
  getSearchViewArticles: (state) => state.searchViewArticles,
  getSearchFilters: (state) => state.searchFilters,
  getCategoriesFilter: (state) => state.categoriesFilters,
  getQuickArticle: (state) => state.quickArticle,
  getRecentArticles: (state) => state.recentArticles,
  getMyArticles: (state) => state.myArticles,
  getMyArticlesFilter: (state) => state.myArticlesFilter,
  getArticlesOnSale: (state) => state.articlesOnSale,

  // Banks
  getBanks: (state) => state.banks,
  getBank: (state) => state.bank,

  // Currencies
  getCurrencies: (state) => state.currencies,
  getCurrency: (state) => state.currency,

  // Measurement Units
  getMeasurementUnits: (state) => state.measurementUnits,

  // Brands
  getBrands: (state) => state.brands,
  getBrand: (state) => state.brand,
  getAllBrands: (state) => state.allBrands,

  // Taxes
  getTaxes: (state) => state.taxes,

  // Express Posts
  getExpressPosts: (state) => state.expressPosts,
  getExpressPost: (state) => state.expressPost,

  // Tabs
  getTabs: (state) => state.tabs,
  getTab: (state) => state.tab,

  // Product sales
  getProductSales: (state) => state.productSales,
  getProductSale: (state) => state.productSale,

  // Interests Areas
  getInterestsAreas: (state) => state.interestsAreas,
  getInterestsArea: (state) => state.interestsArea,

  getCustomerBankAccounts: (state) => state.customerBankAccounts,
  getCustomerBankAccount: (state) => state.customerBankAccount,

  // Blogs
  getBlogs: (state) => state.blogs,
  getRecentBlogs: (state) => state.recentBlogs,
  getBlog: (state) => state.blog,

  // Terms of services
  getTermsOfServices: (state) => state.terms,

  // Attributes
  getAttributes: (state) => state.attributes,
  getAttribute: (state) => state.attribute,
  getAttributesAsObj: (state) => {
    console.error('uslo attributes obj');
    const result = {};
    state.attributes.forEach((item) => {
      result[item.id] = {
        ...item,
        id: item.id,
        title: item.title,
        attributeProperties: item.attributeProperties.map((i) => ({
          label: i.title,
          id: i.id,
        })),
      };
    });

    return result;
  },
  getArticleVariations: (state) => state.articleVariations,

  // HomePage
  getJumbotrons: (state) => state.jumbotrons,
  getHighlightedCategories: (state) => state.highlightedCategories,
  getHighlightedBrand: (state) => state.highlightedBrand,
  getTopBrands: (state) => state.topBrands,
  getWishlist: (state) => state.wishlist,

  // Shopping Carts
  getShoppingCart: (state) => state.shoppingCart,
  getShoppingCarts: (state) => state.shoppingCarts,

  // Orders
  getOrders: (state) => state.orders,
  getOrder: (state) => state.order,

  // Messages
  getMessages: (state) => state.messages,
  getUnreadMessagesCount: (state) => state.unreadMessagesCount,

  // User files
  getUserFiles: (state) => state.userFiles,

  // Tags
  getMostPopularTags: (state) => state.mostPopularTags,

  // Complaints
  getComplaints: (state) => state.complaints,

  // Parameters
  getFreeShippingAmount: (state) => state.freeShippingAmount,
  getAllowOrderingStockZero: (state) => state.allowOrderingStockZero,
  getFreeShippingEnabled: (state) => state.freeShippingEnabled,
  getUseDefaultLanguage: (state) => state.useDefaultLanguage,
  getDefaultLanguage: (state) => state.defaultLanguage,
  getLanguages: (state) => state.languages,

  // Modals
  getOutOfStockModal: (state) => state.outOfStockModal,
};
